import managerBidEditTabSlice from './managerBidEditTab';

export { selectedTabIndexSelector } from './managerBidEditTab';
export const { actions: { setSelectedTab: setSelectedTabAction } } = managerBidEditTabSlice;
export default managerBidEditTabSlice;
